import request from '@utils/request';
// 拉取用户设置项能力配置

const queryAbilityConfig = (params: any) =>
  request({
    url: 'v2/wemeet-ability-logic/query-ability-config',
    data: params,
    type: 'POST',
  });

export async function getAbilityConfig(params: any) {
  try {
    const res = await queryAbilityConfig(params);
    if (res?.code === 0) {
      return res?.data ?? {};
    }
  } catch (err) {
    return {};
  }
}
